import { Directive, Input, ElementRef, OnInit } from '@angular/core';
import { StoreService } from '../services/store.service';
import { Properties } from 'csstype';

@Directive({
	selector: '[appSetCardStyle]',
})
export class SetCardStyleDirective implements OnInit {
	@Input() type;
	@Input() size;
	@Input() over768;

	constructor(private element: ElementRef<HTMLDivElement>, private _ss: StoreService) {}

	// change for berman (20820/1) without affecting other customers
	hasSpecialsIcons = this._ss.CustomerInformation?.HasSpecials === '3' && this._ss.CustomerInformation?.ProductWeightType === '1';

	SeeProductName = this._ss.CustomerInformation?.SeeProductName;
	SeeBarcode = this._ss.CustomerInformation?.SeeBarcode;
	SeeProductId = this._ss.CustomerInformation?.SeeProductId;
	ShowProduct = this._ss.CustomerInformation?.ShowProduct;

	ngOnInit() {
		// Customer 10123.1
		const areAllDetailsHidden = this.SeeProductName === '1' && (this.SeeBarcode === '1' || this.SeeBarcode === '4') && this.SeeProductId === '1';

		const el = this.element.nativeElement;

		const stylesobject: Properties = {};
		const isMainProduct = this.element.nativeElement.classList.contains('IsMainProduct');

		if (this.size === 'small') {
			if (this.type === 'image') {
				stylesobject.maxHeight = areAllDetailsHidden ? '200px' : null;
				stylesobject.maxHeight = areAllDetailsHidden ? '200px' : null;
				stylesobject.height = areAllDetailsHidden ? null : '100px';
				stylesobject.margin = 'auto';
				stylesobject.display = 'flex';
				stylesobject.justifyContent = 'center';

				if (this.ShowProduct === '1') {
					stylesobject.height = '80%';
				}

				if (this.ShowProduct === '8') {
					stylesobject.height = '65px';
				}

				if (this.ShowProduct === '9' || this.ShowProduct === '10') {
					stylesobject.height = '45px';
				}

				if (this.ShowProduct === '11') {
					stylesobject.height = '140px';
				}

				if (this.SeeProductName !== '1' && this.SeeBarcode === '7' && this.SeeProductId === '3') {
					stylesobject.height = '172px';
				}

				if (isMainProduct) {
					stylesobject.height = '224px';
					if (this.over768) {
						stylesobject.height = '190px';
					}
				}
			}

			if (this.type === 'info') {
				stylesobject.top = areAllDetailsHidden ? '30px' : '10px';
				stylesobject.display = areAllDetailsHidden ? 'flex' : null;
				stylesobject.flexDirection = areAllDetailsHidden ? 'column' : null;
				stylesobject.width = areAllDetailsHidden ? null : '99%';
				stylesobject.alignItems = stylesobject.justifyContent = areAllDetailsHidden ? 'center' : null;
				stylesobject.margin = areAllDetailsHidden ? null : 'auto';
				stylesobject.position = 'relative';
			}
		}

		if (!this.type && this.size === 'med') {
			stylesobject.maxWidth = areAllDetailsHidden ? '300px' : null;
			stylesobject.maxHeight = areAllDetailsHidden ? '300px' : null;
			stylesobject.height = areAllDetailsHidden ? null : '150px';
			stylesobject.margin = 'auto';
			stylesobject.display = 'flex';
			stylesobject.justifyContent = 'center';

			if (this.hasSpecialsIcons) {
				stylesobject.height = '120px';
			}

			if (this.ShowProduct === '2' || this.ShowProduct === '3') {
				stylesobject.height = '200px';
			}

			if (this.ShowProduct === '5') {
				stylesobject.height = '215px';
			}

			if (this.SeeProductName !== '1') {
				if (this.SeeBarcode === '7' && this.SeeProductId === '3') {
					stylesobject.height = '212px';
				}

				if (this.SeeBarcode === '1' && this.SeeProductId === '1') {
					stylesobject.height = '250px';

					if (this.ShowProduct === '4') {
						stylesobject.height = '300px';
					}
				}
			}

			if (isMainProduct) {
				stylesobject.height = '280px';
				if (this.hasSpecialsIcons) {
					stylesobject.height = '250px';
				}
			}
		}

		if (!el || !(el instanceof HTMLDivElement)) return;

		for (const key in stylesobject) {
			if (Object.prototype.hasOwnProperty.call(stylesobject, key)) {
				el.style[key] = stylesobject[key];
			}
		}
	}
}
